import React, { useState, useEffect, useReducer } from 'react'
import { Controller } from 'react-hook-form'
import { Table, IconButton, Icon, Button, Row, Col, Checkbox, Uploader } from 'rsuite'
import { initialNewData, getExpandedId, getNewDataEdit } from './IncomeRecordUtils'
import EditSelectCell from '../../components/cell/EditSelectCell'
import EditTextCell from '../../components/cell/EditTextCell'
import EditNumberCell from '../../components/cell/EditNumberCell'
import ConfirmWidget from '../confirm/ConfirmWidget'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import { cloneDeep } from 'lodash-es'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, isImageOrPdf, hasMinValidator } from '../../utils/ValidatorUtils'
import { isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import { getValueFromOptions } from '../../utils/dataUtil'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadInstallmentIncomeDetailAttacthment } from '../../redux/actions/incomeAndExpense'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { budgetFormat } from '../../utils/formatterUtil'
import { v4 as uuidv4 } from 'uuid'
import '../../widgets/projectBasedItemsWidget/styles_table.less'

export default function IncomeRecordTable({
  schema,
  loading,
  isEnableEdit = false,
  register,
  errors,
  control,
  setError,
  setValue,
  getValues,
  clearErrors,
  isViewMode,
  bankAccount,
  isAddDisabled,
  ...props
}) {
  const { isReceiveAnnuity } = props
  //const { register, handleSubmit, errors, control, setError, setValue, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [masterTableData, setMasterTableData] = useState([])
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [showControlEdit, setShowControlEdit] = useState(true)
  const [fileTypeError, setFileTypeError] = useState(true)

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)

  const fixedValue = {
    subProjectTypeCode: '2000', //เงินสนับสนุนโครงการย่อยประเภทค่าตอบแทน
    subProjectTypeCode1: '2001', //เงินสนับสนุนโครงการย่อยประเภทค่าดำเนินการ
    subProjectTypeCode2: '2002', //รับเงินคืนโครงการย่อย
    cashCode: '6100', //เงินสด
    transferCode: '6200', //เงินโอน
    isReceiveAnnuityCode: '4100', //รับเงิยงวด
    interestIncome: '4200', //รับดอกเบี้ยรับ
  }

  useEffect(() => {
    setMasterTableData(schema.values)
    setTableData(schema.values)
    register('table', schema.values || [])
    setValue('table', schema.values || [])
  }, [schema.values])

  useEffect(() => {
    if (isReceiveAnnuity && !isEnableEdit && schema?.values?.length > 0) {
      const newData = schema?.values?.map((row) => {
        return {
          ...row,
          status: null,
        }
      })

      setTableData(newData)
      setValue('table', newData)
      setTimeout(() => {
        forceUpdate()
      }, 500)
    }
  }, [isReceiveAnnuity, isEnableEdit])

  useEffect(() => {
    if (errors) {
      console.log('errors', errors)
      let key = Object.keys(errors)
      if (key.length > 0) {
        notification.open('error', {
          title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
          duration: 5000,
        })
      }
    }
  }, [errors])

  const handleOpenEditRow = (rowData) => {
    const newData = tableData.map((row) => {
      if (row.id == rowData.id) {
        if (rowData.status && rowData.status == 'EDIT') {
          const master = masterTableData.find((item) => item.id == rowData.id)
          row.incomeType = master?.incomeType
          row.subProjectCode = master?.subProjectCode
          row.bankAccount = master?.bankAccount
          row.cashAccountOnHand = master?.cashAccountOnHand
          row.amount = master?.amount
          row.vat = master?.vat
          row.withholding = master?.withholding
          row.receivedAmount = master?.receivedAmount
          row.attachPath = master?.attachPath
          row.isDeleteAttachReceipt = false
          row.status = null
        } else {
          row.status = 'EDIT'
        }
      }
      return row
    })
    // setTableData(newData)
    // setValue('table', newData)
    handleChangeTotal(newData)
  }

  const onDeleteRow = (rowData) => {
    let datas = cloneDeep(tableData)

    datas = datas.filter((e) => e.id != rowData.id)

    var sumObj = {}
    if (datas && datas?.length > 0) {
      sumObj = datas[datas.length - 1]

      sumObj.amount = 0
      sumObj.vat = 0
      sumObj.withholding = 0
      sumObj.receivedAmount = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        id: '',
        //incomeTypeId: '',
        incomeType: '',
        subProjectCode: '',
        bankAccount: '',
        cashAccountOnHand: 'รวม (บาท)',
        amount: 0,
        vat: 0,
        withholding: 0,
        receivedAmount: 0,
        isRowTotal: true,
      }
    }

    datas.forEach((e) => {
      sumObj.amount = sumObj.amount + e.amount
      sumObj.vat = sumObj.vat + e.vat
      sumObj.withholding = sumObj.withholding + e.withholding
      sumObj.receivedAmount = sumObj.receivedAmount + e.receivedAmount
    })

    datas.push(sumObj)

    setTableData(datas)

    setValue('table', datas)
  }
  // setShowControlEdit(!showControlEdit)

  const handleOnClickAddNewData = () => {
    // setTableData()
    let datas = cloneDeep(tableData)

    //var lasted = datas[datas.length-1]
    var runnigNum = 1
    var sumObj = {}
    if (datas && datas?.length > 0) {
      runnigNum = datas.length - 1
      sumObj = datas[datas.length - 1]

      sumObj.amount = 0
      sumObj.vat = 0
      sumObj.withholding = 0
      sumObj.receivedAmount = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        id: '',
        //incomeTypeId: '',
        incomeType: '',
        subProjectCode: '',
        bankAccount: '',
        cashAccountOnHand: 'รวม (บาท)',
        amount: 0,
        vat: 0,
        withholding: 0,
        receivedAmount: 0,
        isRowTotal: true,
      }
    }

    var newObj = {
      id: 'addNew-' + runnigNum + '-' + uuidv4(),
      //incomeTypeId: '1',
      incomeType: '',
      subProjectCode: '',
      bankAccount: '',
      cashAccountOnHand: '',
      amount: 0,
      vat: 0,
      withholding: 0,
      receivedAmount: 0,
      isDeletable: true,
      status: 'EDIT',
    }

    datas.push(newObj)

    datas.forEach((e) => {
      sumObj.amount = sumObj.amount + e.amount
      sumObj.vat = sumObj.vat + e.vat
      sumObj.withholding = sumObj.withholding + e.withholding
      sumObj.receivedAmount = sumObj.receivedAmount + e.receivedAmount
    })

    datas.push(sumObj)

    setTableData(datas)
    setValue('table', datas)
  }

  const onChangeIncomeType = (index, value) => {
    console.log(value)
    let datas = cloneDeep(tableData)

    datas[index].incomeType = value

    if (
      value == fixedValue.subProjectTypeCode ||
      value == fixedValue.subProjectTypeCode1 ||
      value == fixedValue.subProjectTypeCode2
    ) {
      datas[index].subProjectCode = schema?.subProjectCode?.options[0]?.value || ''
      setValue(
        `table[${index}].${schema.subProjectCode.name}`,
        schema?.subProjectCode?.options[0]?.value || ''
      )
    } else {
      datas[index].subProjectCode = ''
      setValue(`table[${index}].${schema.subProjectCode.name}`, '')
    }

    if (value != fixedValue.interestIncome) {
      setValue(`${schema.vat.name}_${datas[index].id}`, 0)
      setValue(`${schema.withholding.name}_${datas[index].id}`, 0)

      datas[index].vat = null
      datas[index].withholding = null
    }

    setTableData(datas)
    setValue('table', datas)
  }

  const onChangeSubProjectCode = (index, value) => {
    let datas = cloneDeep(tableData)
    datas[index].subProjectCode = value
    setTableData(datas)
    setValue('table', datas)
  }

  const onChangeBankAccount = (index, value) => {
    let datas = cloneDeep(tableData)
    datas[index].bankAccount = value
    setTableData(datas)
    setValue('table', datas)
  }

  const onChangeTableValue = (index, value = 0, key, id) => {
    let datas = cloneDeep(tableData)
    datas[index][key] = value

    if (key == schema.amount.name) {
      // let vat = 0
      // vat = (value * 7) / 107
      // datas[index].vat = parseFloat(vat.toFixed(2))
      // setValue(`${schema.vat.name}_${id}`, parseFloat(vat.toFixed(2)) || 0)

      datas[index].receivedAmount = value - datas[index].withholding
      setValue(`${schema.receivedAmount.name}_${id}`, value - datas[index].withholding)
    }

    if (key == schema.withholding.name) {
      datas[index].receivedAmount = datas[index].amount - value
      setValue(`${schema.receivedAmount.name}_${id}`, datas[index].amount - value)
    }

    if (key == schema.receivedAmount.name) {
      if (value > datas[index].amount) {
        datas[index].receivedAmount = datas[index].amount
        setValue(`${schema.receivedAmount.name}_${id}`, datas[index].amount)
      } else {
        // datas[index].receivedAmount = value
        // setValue(`${schema.receivedAmount.name}_${id}`, value)
      }
    }

    //setTableData(datas)
    //setValue('table', datas)
    handleChangeTotal(datas)
  }

  const handleChangeTotal = (dataTable) => {
    if (dataTable?.length > 0) {
      var totalAmount = 0
      var totalVat = 0
      var totalWithholding = 0
      var totalReceivedAmount = 0
      dataTable.forEach((e) => {
        if (!e.isRowTotal) {
          totalAmount = totalAmount + e.amount
          totalVat = totalVat + e.vat
          totalWithholding = totalWithholding + e.withholding
          totalReceivedAmount = totalReceivedAmount + e.receivedAmount
        }
      })

      dataTable[dataTable.length - 1].amount = totalAmount
      dataTable[dataTable.length - 1].vat = totalVat
      dataTable[dataTable.length - 1].withholding = totalWithholding
      dataTable[dataTable.length - 1].receivedAmount = totalReceivedAmount

      setTableData(dataTable)
      setValue('table', dataTable)
    }
  }

  const onChangeTableFile = (index, value, key) => {
    let datas = cloneDeep(tableData)
    datas[index][key] = value

    setTableData(datas)
    setValue('table', datas)
  }

  const onDeleteFileInRowData = (index) => {
    let datas = cloneDeep(tableData)
    datas[index].attachPath = null
    datas[index].isDeleteAttachReceipt = true
    setTableData(datas)
    setValue('table', datas)
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadInstallmentIncomeDetailAttacthment(fileObj.id)
      var fileName = fileObj.name

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <div className="table-affix-header">
        <Table
          shouldUpdateScroll={false}
          wordWrap
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
          headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
          affixHeader
        >
          <Column width={70} align="center">
            <HeaderCell>
              <p style={{ color: '#313131' }}>
                <b>ลำดับ</b>
              </p>
            </HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return ''
                }
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={250} minWidth={250} flexGrow={1}>
            <HeaderCell style={styleHeaderCell}>รายการ/ประเภทรายรับ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (isReceiveAnnuity) {
                  return rowData.incomeTypeName
                }

                if (rowData.status != 'EDIT') {
                  return getValueFromOptions(schema?.incomeType?.options, rowData?.incomeType) //rowData.incomeType
                }

                return (
                  <EditSelectCell
                    id={`${schema.incomeType.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.incomeType.name}`}
                    rowData={rowData}
                    rowSchema={{
                      ...schema.incomeType,
                      options:
                        schema.incomeType?.options?.filter(
                          (i) => i.value != fixedValue.isReceiveAnnuityCode
                        ) || [],
                    }}
                    dataKey={schema.incomeType.name}
                    register={register}
                    control={control}
                    errors={errors}
                    disabled={isReceiveAnnuity}
                    cleanable={false}
                    disabledItemValues={
                      schema?.subProjectCode?.options?.length == 0
                        ? [
                            fixedValue.subProjectTypeCode,
                            fixedValue.subProjectTypeCode1,
                            fixedValue.subProjectTypeCode2,
                          ]
                        : []
                    }
                    onChangeCell={(value) => onChangeIncomeType(index, value)}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={250}>
            <HeaderCell style={styleHeaderCell}>โครงการย่อย/บัญชีธนาคาร</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return (
                    <div style={{ width: '100%', textAlign: 'right' }}>
                      <b>{rowData.summaryLabel || 'รวม (บาท)'}</b>
                    </div>
                  )
                } else {
                  if (rowData.status != 'EDIT') {
                    return rowData.incomeType == fixedValue.cashCode ||
                      rowData.incomeType == fixedValue.transferCode
                      ? //|| rowData.incomeType == fixedValue.interestIncome
                        rowData.bankAccountName
                      : rowData.subProjectCodeName

                    // return getValueFromOptions(
                    //   schema?.subProjectCode?.options,
                    //   rowData?.subProjectCode
                    // ) //rowData.incomeType
                  }
                  // const table = getValues(`table`) || []
                  //const value = table[index][schema.incomeType.name]
                  if (
                    rowData.incomeType == fixedValue.subProjectTypeCode ||
                    rowData.incomeType == fixedValue.subProjectTypeCode1 ||
                    rowData.incomeType == fixedValue.subProjectTypeCode2
                  ) {
                    return (
                      <EditSelectCell
                        //id={`${schema.subProjectCode.name}_${rowData.id}`}
                        id={`table[${index}].${schema.subProjectCode.name}`}
                        rowData={rowData}
                        rowSchema={schema.subProjectCode}
                        dataKey={schema.subProjectCode.name}
                        register={register}
                        control={control}
                        errors={errors}
                        cleanable={false}
                        disabled={isReceiveAnnuity}
                        onChangeCell={(value) => onChangeSubProjectCode(index, value)}
                      />
                    )
                  } else if (
                    rowData.incomeType == fixedValue.cashCode ||
                    rowData.incomeType == fixedValue.transferCode
                    // || rowData.incomeType == fixedValue.interestIncome
                  ) {
                    return (
                      <EditSelectCell
                        id={`table[${index}].${bankAccount.name}`}
                        rowData={rowData}
                        rowSchema={bankAccount}
                        dataKey={bankAccount.name}
                        register={register}
                        control={control}
                        errors={errors}
                        disabled={isReceiveAnnuity}
                        onChangeCell={(value) => onChangeBankAccount(index, value)}
                      />
                    )
                  }

                  return ''
                }
              }}
            </Cell>
          </Column>

          <Column width={180} align="right">
            <HeaderCell style={styleHeaderCell}>จำนวนเงินเต็ม</HeaderCell>
            <Cell align="right">
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return (
                    <span className={'cost-total-summary'}>
                      {budgetFormat(rowData.amount || 0)}
                    </span>
                  )
                }
                return (
                  <EditNumberCell
                    id={`${schema.amount.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.amount.name}`}
                    rowData={rowData}
                    dataKey={schema.amount.name}
                    register={register}
                    control={control}
                    errors={errors}
                    isRequired={true}
                    isBudgetFormat={true}
                    disabled={isReceiveAnnuity}
                    styleSheet={{ marginTop: 8, textAlign: 'right' }}
                    onChangeCell={(value) =>
                      onChangeTableValue(index, value, schema.amount.name, rowData.id)
                    }
                    allowNegative={!hasMinValidator(schema.amount.validators)}
                  />
                )
              }}
            </Cell>
          </Column>
          <Column width={180} align="right">
            <HeaderCell style={styleHeaderCell}>ภาษีมูลค่าเพิ่ม</HeaderCell>
            <Cell align="right">
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return (
                    <span className={'cost-total-summary'}>{budgetFormat(rowData.vat || 0)}</span>
                  )
                }
                return (
                  <EditNumberCell
                    id={`${schema.vat.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.vat.name}`}
                    rowData={rowData}
                    dataKey={schema.vat.name}
                    register={register}
                    control={control}
                    errors={errors}
                    isRequired={true}
                    isBudgetFormat={true}
                    disabled={isReceiveAnnuity || rowData.incomeType != fixedValue.interestIncome}
                    styleSheet={{ marginTop: 8, textAlign: 'right' }}
                    onChangeCell={(value) =>
                      onChangeTableValue(index, value, schema.vat.name, rowData.id)
                    }
                    allowNegative={!hasMinValidator(schema.vat.validators)}
                  />
                )
              }}
            </Cell>
          </Column>
          <Column width={180} align="right">
            <HeaderCell style={styleHeaderCell}>หัก ณ.ที่จ่าย</HeaderCell>
            <Cell align="right">
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return (
                    <span className={'cost-total-summary'}>
                      {budgetFormat(rowData.withholding || 0)}
                    </span>
                  )
                }
                return (
                  <EditNumberCell
                    id={`${schema.withholding.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.withholding.name}`}
                    rowData={rowData}
                    dataKey={schema.withholding.name}
                    register={register}
                    control={control}
                    errors={errors}
                    isRequired={true}
                    isBudgetFormat={true}
                    disabled={isReceiveAnnuity || rowData.incomeType != fixedValue.interestIncome}
                    styleSheet={{ marginTop: 8, textAlign: 'right' }}
                    onChangeCell={(value) =>
                      onChangeTableValue(index, value, schema.withholding.name, rowData.id)
                    }
                    allowNegative={!hasMinValidator(schema.withholding.validators)}
                  />
                )
              }}
            </Cell>
          </Column>
          <Column width={180} align="right">
            <HeaderCell style={{ ...styleHeaderCell }}>จำนวนเงินรับจริง (บาท)</HeaderCell>
            {/* <Cell dataKey="amount" /> */}
            <Cell align="right">
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return (
                    <span className={'cost-total-summary'}>
                      {budgetFormat(rowData.receivedAmount)}
                    </span>
                  )
                }
                return (
                  <EditNumberCell
                    id={`${schema.receivedAmount.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.receivedAmount.name}`}
                    rowData={{
                      ...rowData,
                      status: isEnableEdit && isReceiveAnnuity ? rowData.status : null,
                    }}
                    dataKey={schema.receivedAmount.name}
                    register={register}
                    control={control}
                    errors={errors}
                    isRequired={true}
                    isBudgetFormat={true}
                    disabled={!isEnableEdit && isReceiveAnnuity}
                    styleSheet={{ marginTop: 8, textAlign: 'right' }}
                    onChangeCell={(value) =>
                      onChangeTableValue(index, value, schema.receivedAmount.name, rowData.id)
                    }
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={200} align="center">
            <HeaderCell align="center" style={styleHeaderCell}>
              {schema.attachReceipt.label}
            </HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.status == 'EDIT') {
                  //let table = getValues(`table`)
                  return (
                    <>
                      {rowData.attachPath ? (
                        <div style={{ marginTop: 5 }}>
                          <IconButton
                            appearance="ghost"
                            className="rs-btn-ghost-edit"
                            icon={<Icon icon="eye" className="bt-gost-icon-radius-edit" />}
                            onClick={() => onPreview(rowData)}
                            size="sm"
                          >
                            แสดง
                          </IconButton>
                          <IconButton
                            appearance="ghost"
                            className="rs-btn-ghost-cancel"
                            icon={
                              <Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />
                            }
                            onClick={() => {
                              onDeleteFileInRowData(index)
                            }}
                            size="sm"
                            style={{ marginLeft: 5 }}
                          >
                            ลบ
                          </IconButton>
                        </div>
                      ) : (
                        <Col>
                          <ErrorMessage error={errors[schema.attachReceipt.name]} />
                          <Controller
                            // key={`${schema.attachReceipt.name}-${rowData.id}`}
                            // name={`${schema.attachReceipt.name}-${rowData.id}`}
                            key={`table[${index}].${schema.attachReceipt.name}`}
                            name={`table[${index}].${schema.attachReceipt.name}`}
                            control={control}
                            rules={isValidators(schema.attachReceipt.validators)}
                            defaultValue={''}
                            render={(props) => {
                              if (props.value) {
                                return (
                                  <div
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    <p>{props?.value[0]?.name || 'file name'}</p>

                                    <IconButton
                                      appearance="link"
                                      //className="rs-btn-ghost-cancel"
                                      icon={<Icon icon="close" style={{ color: 'gray' }} />}
                                      onClick={(e) => {
                                        let files = []
                                        //files.push(fileList[fileList.length - 1])
                                        props.onChange()
                                        //onChangeTableValue(index, null, schema.attachReceipt.name)
                                      }}
                                      //disabled={!rowData.enableDelete || rowData.isChecked}
                                    />
                                  </div>
                                )
                              } else {
                                return (
                                  <Uploader
                                    autoUpload={false}
                                    disabled={schema.attachReceipt.disabled}
                                    fileListVisible={true}
                                    listType="picture-text"
                                    fileList={props.value || []}
                                    onChange={(fileList) => {
                                      if (isEmpty(fileList)) {
                                        props.onChange(undefined)
                                      } else {
                                        let file = fileList[fileList.length - 1]

                                        if (isImageOrPdf(file.blobFile.type)) {
                                          props.onChange(fileList)
                                          setFileTypeError(false)
                                          onChangeTableFile(
                                            index,
                                            fileList,
                                            schema.attachReceipt.name
                                          )
                                        } else {
                                          notification.open('error', {
                                            title: 'ชนิดที่รองรับ png, jpeg, jpg, pdf',
                                            duration: 5000,
                                          })
                                          setFileTypeError(true)
                                        }
                                      }
                                    }}
                                    draggable
                                  >
                                    <div style={{ lineHeight: '20px', marginTop: 5 }}>
                                      <Icon icon="upload2" />
                                      <small
                                        style={{
                                          display: 'block',
                                          whiteSpace: 'nowrap',
                                          textOverflow: 'ellipsis',
                                        }}
                                      ></small>
                                    </div>
                                  </Uploader>
                                )
                              }
                            }}
                          />
                        </Col>
                      )}
                    </>
                  )
                } else {
                  return (
                    <>
                      {rowData.attachPath && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius-edit" />}
                          onClick={() => onPreview(rowData)}
                          size="sm"
                        >
                          แสดง
                        </IconButton>
                      )}
                    </>
                  )
                }
              }}
            </Cell>
          </Column>

          <Column width={180} align="center">
            <HeaderCell>วันที่บันทึกรายการ</HeaderCell>
            <Cell dataKey="createDate" />
          </Column>

          {!isViewMode && (
            <Column width={200} align="center" fixed="right">
              <HeaderCell style={styleHeaderCell}>จัดการรายการ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  if (index == tableData.length - 1) {
                    return (
                      <>
                        {!isReceiveAnnuity && (
                          <IconButton
                            appearance="ghost"
                            icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
                            onClick={handleOnClickAddNewData}
                            disabled={isReceiveAnnuity || isAddDisabled}
                            style={{ marginLeft: 5 }}
                          >
                            {'เพิ่มรายการ'}
                          </IconButton>
                        )}
                      </>
                    )
                  }

                  if (rowData.isRowTotal) {
                    return ''
                  }

                  return (
                    <>
                      {rowData.id?.indexOf('addNew') == -1 && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          icon={
                            <Icon
                              icon={rowData.status == 'EDIT' ? 'close' : 'edit'}
                              className="bt-gost-icon-radius-edit"
                            />
                          }
                          onClick={() => handleOpenEditRow(rowData)}
                          disabled={!isEnableEdit && isReceiveAnnuity}
                          size="sm"
                        >
                          {rowData.status == 'EDIT' ? 'ยกเลิก' : 'แก้ไข'}
                        </IconButton>
                      )}
                      {!isReceiveAnnuity && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                          onClick={() => {
                            onDeleteRow(rowData)
                          }}
                          size="sm"
                          style={{ marginLeft: 5 }}
                        >
                          ลบ
                        </IconButton>
                      )}
                    </>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </div>

      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        // onConfirm={handleOnConfirmDelete}
      />
    </>
  )
}
